<script setup lang="ts">
import type { Dictionary } from "@/types";

import { useDisplay } from "vuetify";

import { userIcon } from "@/utilities/discord";

const props = defineProps<{
  dictionary: Dictionary;
  isSelected: boolean;
  showMember: boolean;
}>();

const emit = defineEmits<{
  (e: "toggle"): void;
}>();

const { mobile } = useDisplay();
</script>

<template>
  <div class="d-flex w-100">
    <div class="p-dictionary__checkcell">
      <v-checkbox
        :model-value="props.isSelected"
        hide-details
        density="compact"
        @update:model-value="emit('toggle')"
        @click.stop
      />
    </div>
    <div
      class="p-dictionary__cell is-word"
      :class="{ 'text-caption': mobile }"
    >
      {{ props.dictionary.before }}
    </div>
    <div
      class="p-dictionary__cell is-word"
      :class="{ 'text-caption': mobile }"
    >
      {{ props.dictionary.after }}
    </div>
    <div
      v-if="props.showMember"
      class="p-dictionary__cell p-dictionary__cell-user d-flex align-center"
      :class="{ 'justify-center': mobile }"
    >
      <template v-if="props.dictionary.user">
        <v-avatar
          :color="props.dictionary.user.accent_color || 'primary'"
          size="32"
        >
          <v-img
            :src="userIcon(props.dictionary.user)"
            width="32"
          />
        </v-avatar>
        <div
          v-if="!mobile"
          class="p-dictionary__cell-user_name ml-1"
        >
          <div class="text-subtitle-2">
            {{ props.dictionary.user.nick || props.dictionary.user.name }}
          </div>
          <div class="text-caption text-grey">{{ props.dictionary.user.username }}</div>
        </div>
      </template>
    </div>
  </div>
</template>
